import React from 'react';
import PropTypes from 'prop-types';
import Fieldset from 'components/Fieldset';

const _ManualAddress = ({ address, address2, postal, city, country, onChange, onFocus }) => (
  <>
    <Fieldset
      field={address}
      name="address"
      inputType="text"
      labelText="Address"
      autoComplete="billing address-line1"
      onChange={onChange}
      onFocus={onFocus}
      hideAsterisk
    />
    <Fieldset
      field={address2}
      name="address2"
      inputType="text"
      labelText="Apartment, suite, etc."
      autoComplete="billing address-line2"
      onChange={onChange}
      onFocus={onFocus}
      showOptional
    />
    <Fieldset
      field={postal}
      name="postal"
      inputType="text"
      labelText="Postcode"
      autoComplete="billing postal-code"
      onChange={onChange}
      onFocus={onFocus}
      hideAsterisk
    />
    <Fieldset
      field={city}
      name="city"
      inputType="text"
      labelText="City"
      autoComplete="billing address-level2"
      onChange={onChange}
      onFocus={onFocus}
      hideAsterisk
    />
    <Fieldset
      field={country}
      name="country"
      inputType="text"
      labelText="Country"
      onChange={onChange}
      onFocus={onFocus}
      editable={false}
      hideAsterisk
    />
  </>
);

_ManualAddress.propTypes = {
  address: PropTypes.object.isRequired,
  address2: PropTypes.object.isRequired,
  postal: PropTypes.object.isRequired,
  city: PropTypes.object.isRequired,
  country: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired
};

export default _ManualAddress;
